


































import { Component, Vue, Prop, PropSync, Watch, Emit } from 'vue-property-decorator';
import { getWxConfig } from '@/store/checkIn';
import {isWechat,geMobiletCurrentURL} from '@/utils/common';

@Component({
  components: {

  },
})
export default class samllProgram extends Vue {
  @PropSync('show', { type: Boolean, default: false }) showSync!: boolean;
  @Prop(String) readonly username !: string
  @Prop(String) readonly path !: string
  @Prop(String) readonly btnName !: string

  isWechatClient = isWechat;

  created(){
    let newUrl = geMobiletCurrentURL();
    getWxConfig({url:newUrl}).then((config:any) => {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      wx.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['wx-open-launch-weapp'], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表
      });
      // @ts-ignore
      // eslint-disable-next-line no-undef
      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });
      // @ts-ignore
      // eslint-disable-next-line no-undef
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
      });
    });
  }

  onBeforeClose(action:string, done:any){
    this.$emit("onClose");
    return done()//允许关闭
  }

}
